import { useNavigate } from "react-router-dom";
import { useState } from "react";
import AvatarChoiceScreen from "../../compoment/AvatarChoiceScreen";
import { RESTORE_SELECTION } from "../../utils/backNavigation";

const ChooseAvatarScreen = () => {
    const navigate = useNavigate();
    // On your own → this is the last step (RELEASE MY WISH);
    // with a friend → NEXT to the friend's avatar.
    const [isOnOwn] = useState(() => localStorage.getItem("join") === "I am on my own");

    return (
        <AvatarChoiceScreen
            title={
                <>
                    CHOOSE YOUR
                    <br />
                    AVATAR
                </>
            }
            groupLabel="Choose your avatar"
            storageKey="gender"
            onBack={() => navigate("/today-joining", RESTORE_SELECTION)}
            isFinalStep={isOnOwn}
            onNext={() => navigate("/choose-friend-avatar")}
            // The wish payload includes friendGender when present; drop any stale one.
            onBeforeRelease={() => localStorage.removeItem("friendGender")}
        />
    );
};

export default ChooseAvatarScreen;
